import React from "react";
import { NakiMobileHandheldFeaturedSectionTemplate } from "themes/administration/naki-mobile/pages";
import { NakiMobileHandheldFeaturedSectionViewStore } from "administration/naki-mobile/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiMobileHandheldFeaturedSectionViewStore(rootStore, componentProps),
    "nakiMobileHandheldFeaturedSectionViewStore"
)
class NakiMobileHandheldFeaturedSection extends React.Component {
    render() {
        return <NakiMobileHandheldFeaturedSectionTemplate {...this.props} />;
    }
}

export default NakiMobileHandheldFeaturedSection;
